<main *ngIf="pageData" [ngClass]="{'dark': pageData.block[0] && pageData.block[0].darkMode}" >
    <div class="block-content" *ngFor="let block of pageData.block">
        <app-banner *ngIf="block['__component'] == 'blocks.banner'" [props]="block"></app-banner>
        <app-gallery *ngIf="block['__component'] == 'blocks.gallery'" [props]="block"></app-gallery>
        <app-columns *ngIf="block['__component'] == 'blocks.columns'" [props]="block"></app-columns>
    </div>
</main>